import { render } from "./Operate.vue?vue&type=template&id=81a5f4cc"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"

import exportComponent from "/home/runcloud1user/webapps/brightflame/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__